import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ViewChild
} from '@angular/core';
import { AdvisorIncentiveWorkshopName } from '../../../models/_enum-collections';
import { CommonInputModel } from '../../../models/common-input.model';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { IncentiveDetails } from '../../../models/incentive-details.model';
import { PartnerPaymentDetails } from '../../../models/partner-payment-details.model';
import { CommonSharedModule } from '../../common/shared.module';
import { DashboardService } from '../../services/dashboard.service';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { IncentiveDetailsHeaderComponent } from './incentive-details-header/incentive-details-header.component';
import { IncentiveDetailsComponent } from './incentive-details/incentive-details.component';
import { IncentivePaymentInfoComponent } from './incentive-payment-info/incentive-payment-info.component';
import { IncentivePaymentMilestoneTwoComponent } from './incentive-payment-milestone-two/incentive-payment-milestonetwo.component';
import { IncentivePoeSubmissionComponent } from './incentive-poe-submission/incentive-poe-submission.component';
import { PartnerDetailsComponent } from './partner-details/partner-details.component';
import { PaymentProfileComponent } from './payment-profile/payment-profile.component';

@Component({
  selector: 'app-edit-incentive',
  templateUrl: './edit-incentive.component.html',
  styleUrls: ['./edit-incentive.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    PartnerDetailsComponent,
    IncentiveDetailsHeaderComponent,
    PaymentProfileComponent,
    CustomerDetailsComponent,
    IncentiveDetailsComponent,
    IncentivePaymentInfoComponent,
    IncentivePaymentMilestoneTwoComponent,
    IncentivePoeSubmissionComponent
  ]
})
export class EditIncentiveComponent implements OnInit {
  @Output() closeEditSidebar = new EventEmitter<boolean>();
  @Output() showFullscreen = new EventEmitter<boolean>();
  @Output() refreshPartnerInput = new EventEmitter<void>();
  @Input() incentiveId!: number;
  isFullScreen!: boolean;
  colorLoader = true;
  incentiveDetails!: IncentiveDetails;
  profilePaymentDetails!: PartnerPaymentDetails;
  isOptOutPartner!: boolean;

  @ViewChild('incentiveDetailsHeader', { static: false })
  incentiveDetailsHeader!: IncentiveDetailsHeaderComponent;
  @ViewChild('incentivePoeSubmission', { static: false })
  incentivePoeSubmission!: IncentivePoeSubmissionComponent;
  @Input() engagementEditInput!: EngagementEditInput;

  constructor(
    private localStorage: LocalStorageService,
    private dashboardServices: DashboardService,
    private osmEdit: OsmosisEditService
  ) {}

  ngOnInit() {
    this.isFullScreen = this.localStorage.getFullscreenMode();
    this.loadData();
    this.isOptOutPartner = this.engagementEditInput.isOptOutPartner || false;
  }

  showFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.showFullscreen.emit(this.isFullScreen);
  }

  closeSidebar() {
    this.localStorage.setFullscreenMode(this.isFullScreen);
    this.closeEditSidebar.emit(false);
  }

  loadData() {
    this.osmEdit
      .getIncentiveDataByRequestDetailsById(this.incentiveId)
      .subscribe(result => {
        this.incentiveDetails = result;
        this.colorLoader = false;
        this.getPartnerPaymentDetails();
      });
  }

  get isMCIWorkshop() {
    return this.incentiveDetails.deliveryName ===
      AdvisorIncentiveWorkshopName.Frontline_Worker_MCI ||
      this.incentiveDetails.deliveryName ===
        AdvisorIncentiveWorkshopName.Microsoft_Viva_MCI
      ? true
      : false;
  }

  refresh() {
    this.loadData();
    this.incentiveDetailsHeader.getNotesList();
    this.incentiveDetailsHeader.setValues();
    this.refreshPartnerInput.emit();
  }

  onTabChange(event) {
    if (event.index == 6) {
      this.incentivePoeSubmission.RefreshTab();
    }
  }

  getPartnerPaymentDetails() {
    const commonInputModel: CommonInputModel = {
      mpnid: this.incentiveDetails?.partnerMPNID?.toString(),
      programTypeId: this.incentiveDetails.programTypeId
    };

    this.dashboardServices
      .getPartnerAndPaymentDetails(commonInputModel)
      .subscribe(partnerPaymentDetails => {
        this.profilePaymentDetails = partnerPaymentDetails;
      });
  }
}
